module.exports = __webpack_public_path__ + "img/notification-history.svg";